import {HttpClient} from '@angular/common/http';
import {Level} from './level';

type Constructor<T> = new (...args: any[]) => T;
export class LevelsBase<TLevel> {
  index = 0;
  names: string[];
  levels: {[name: string]: TLevel} = {};
  loaded = false;

}
export class Levels<TLevel extends Level<LevelType>, LevelType> extends LevelsBase<TLevel> {

  constructor(private levelConstructor : Constructor<TLevel>) {
    super();
  }

  async load(httpClient: HttpClient): Promise<void>
  {
    if (this.names) { return; }
    this.names = (await httpClient.get(`/assets/levels.json`)
      .toPromise()) as string[];
    for (const name of this.names){
      this.levels[name] = new this.levelConstructor(name);
      await this.levels[name].load(httpClient);
    }
    this.loaded = true;
  }

  // noinspection JSUnusedGlobalSymbols
  reset(value = 0): void {
    this.index = value;
  }

  indexOf(name: string): number {
    return this.names.indexOf(name);
  }

  // noinspection JSUnusedGlobalSymbols
  get isLast(): boolean {
    return this.names.length <= this.index + 1;
  }

  get current(): TLevel {
    return this.levels[this.names[this.index]];
  }

  get currentName(): string {
    return this.names[this.index];
  }

  get next(): TLevel {
    this.index ++;
    return this.current;
  }
}
